import { useQuery } from '@tanstack/react-query'
import professionalsService from 'services/professionals'

interface AutoSuggestProfessionalName {
  professionalOptions: { value: number; label: string }[]
  isLoading: boolean
}

interface SearchInfo {
  profileRole: string
  startDate: string
  endDate: string
}

const MIN_VALUE_TO_SEARCH_TEXT = 2
const ONE_HOUR_IN_MILLISECONDS = 1000 * 60 * 60

export const useAutoSuggestProfessionalName = (term: string, searchInfo: SearchInfo): AutoSuggestProfessionalName => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['autoSuggestProfessionalName', term],
    queryFn: () => professionalsService.listProfessionalsAutoSuggest({
      fullNameContains: term,
      page: 1,
      perPage: 50,
      startDate: searchInfo.startDate,
      endDate: searchInfo.endDate,
      profileRole: searchInfo.profileRole,
    }),
    enabled: term.length >= MIN_VALUE_TO_SEARCH_TEXT,
    staleTime: ONE_HOUR_IN_MILLISECONDS,
    cacheTime: ONE_HOUR_IN_MILLISECONDS,
    retry: false,
  })

  if (!data || isError) {
    return {
      professionalOptions: [],
      isLoading
    }
  }

  const professionalOptions = data.professionals.map((professional) => ({
    value: professional.id,
    label: professional.fullName,
  }))

  return {
    professionalOptions,
    isLoading
  }
}